import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DateFormatDirective} from './date-format.directive';
import {NzDatePickerModule} from 'ng-zorro-antd/date-picker';
import {InputNumberFormatDirective} from './inputNumber.directive';
import {ReplaceFormValueDirective} from './replace-form-value.directive';
import {CsSelectUpdatePositionDirective} from "./cs-select-update-position.directive";
import {CsSelectOptionsDirective} from './cs-select-options.directive';
import {ReplaceSpecialDirective} from './replace-special.directive';
import {SetMaxlengthInputDirective} from './set-maxlength-input.directive';
import {TrimSpaceInputDirective} from './trim-space-input.directive';
import {DocumentNotationDirective} from './document-notation.directive';
import {CsAutocompleteDirective} from './cs-autocomplete.directive';
import {CsAutoCplControlDirective} from "./cs-auto-cpl-control.directive";
import { CopyTextDirective } from './copyText.directive';
import {AddressSelectorDirective} from "./address-selector.directive";
import {vssProviders} from '../../vss.providers';
import {VssDragDropFileUploadDirective} from './vss-drag-drop-file-upload.directive';
import { blockWhiteSpaceDirective } from './block-whitespace.directive';

@NgModule({
  imports: [CommonModule, NzDatePickerModule],
  declarations: [
    DateFormatDirective,
    InputNumberFormatDirective,
    ReplaceFormValueDirective,
    CsSelectUpdatePositionDirective,
    CsSelectOptionsDirective,
    ReplaceSpecialDirective,
    SetMaxlengthInputDirective,
    TrimSpaceInputDirective,
    DocumentNotationDirective,
    CsAutocompleteDirective,
    CsAutoCplControlDirective,
    CopyTextDirective,
    AddressSelectorDirective,
    VssDragDropFileUploadDirective,
    blockWhiteSpaceDirective
   ],
  exports: [
    DateFormatDirective,
    InputNumberFormatDirective,
    ReplaceFormValueDirective,
    CsSelectUpdatePositionDirective,
    CsSelectOptionsDirective,
    ReplaceSpecialDirective,
    SetMaxlengthInputDirective,
    TrimSpaceInputDirective,
    DocumentNotationDirective,
    CsAutocompleteDirective,
    CsAutoCplControlDirective,
    CopyTextDirective,
    AddressSelectorDirective,
    VssDragDropFileUploadDirective,
    blockWhiteSpaceDirective
  ],
  providers: [...vssProviders]
})
export class VssUiDirectivesModule {
}
